module.exports = __webpack_public_path__ + "img/tablet.1bcb0001.svg";